import { EltModelsPage } from '@salescore/client-feature-setting'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import type { ReactElement } from 'react'
import { z } from 'zod'

const Page = (): ReactElement => {
  const navigate = useNavigate()
  const { organizationId } = Route.useParams()
  const { connectionId, tab } = Route.useSearch()

  return (
    <EltModelsPage
      connectionId={connectionId}
      tab={tab}
      redirectToEltModel={(modelName: string) => {
        void navigate({
          to: '/o/$organizationId/v2/settings/elt_models/$modelName/form',
          params: {
            organizationId,
            modelName,
          },
        })
      }}
    />
  )
}

export const Route = createFileRoute('/o/$organizationId/v2/settings/elt_models/')({
  validateSearch: (search) =>
    z.object({ connectionId: z.string().optional(), tab: z.string().optional() }).parse(search),
  component: Page,
})
